@if (is_game_active()){

  <div class="layout-container">

    <header class="board-header">
      <button class="icon-button" (click)="exitBoard()" title="Exit Game">
        <img src="assets/arrow_back.svg" alt="Back" />
      </button>

      <button class="icon-button" (click)="toggleSound()" [title]="is_sound_on() ? 'Mute' : 'Unmute'">
        <img [src]="is_sound_on() ? 'assets/sound_on.svg' : 'assets/sound_off.svg'" alt="Sound Toggle" />
      </button>
    </header>

    <div class="game-stats-bar">
      <div class="stat-item">
        <span class="stat-label">TIME</span>
        <span class="stat-value monospace">{{rounded_time()}}</span>
      </div>
      <div class="stat-item">
        <span class="stat-label">PTS</span>
        <span class="stat-value">{{points()}}</span>
      </div>
    </div>

    <main class="prompter-main">

      @if (is_round_active()){
        <div class="word-display">
          <p class="current-word">{{current_word()}}</p>
        </div>
      }
      @else{
        <div class="waiting-message">
          <p>Shhh! Wait for the round to start.</p>
        </div>
      }

    </main>

    <footer class="board-footer">
      <div class="info-badges">
        <div class="badge">
          <span>Passes:</span>
          <strong>{{passes()}}</strong>
        </div>
        <div class="badge">
          <span>Doubles:</span>
          <strong>{{doubles()}}</strong>
        </div>
      </div>
    </footer>

  </div>

}
@else{

  <app-end-game
    [points]="points()"
    [passes]="passes()"
    [doubles]="doubles()"
  />
  
}
